import { formatAddress, currencyFormat } from "@/utils";
import type { AlgoliaOrder } from "@/types";

/**
 * Converts a listStoreOrders node (GraphQL) to AlgoliaOrder format
 * so that KanbanCard, KanbanModal, and OrderTable continue to function without changes.
 */
export function orderListNodeToAlgoliaOrder(
    node: any,
    accountId: string,
    storeId: string,
): AlgoliaOrder {
    const addr = node?.delivery_address || {};
    const customer =
        [addr.first_name, addr.last_name].filter(Boolean).join(" ") || "";
    const deliveryDetails = node?.delivery_details || {};
    const type = deliveryDetails?.pickup
        ? "pickup"
        : deliveryDetails?.delivery
        ? "delivery"
        : "";

    const entityId = node?.entity_id ?? "";
    return {
        objectID: entityId,
        entity_id: entityId,
        address: node?.delivery_address
            ? formatAddress(node.delivery_address)
            : "",
        customer,
        email: node?.email ?? "",
        status: node?.status ?? "PENDING",
        created_at: node?.created_at ?? "",
        order_number: node?.order_number ?? "",
        jane_store: { id: "", name: "" },
        city: addr?.city ?? "",
        delivery_time_window: "",
        delivery: {
            delivery: deliveryDetails?.delivery ? "yes" : "no",
            start: deliveryDetails?.deliver_after,
            end: deliveryDetails?.deliver_before,
        },
        type,
        total_price: currencyFormat(node?.total_price ?? 0),
        account_id: accountId,
        store_id: storeId,
        reservation_start_window:
            deliveryDetails?.deliver_after ??
            deliveryDetails?.deliver_before ??
            "",
        reservation_start_window_timestamp: "",
    };
}
